import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h-text-center h-mv-20" }
const _hoisted_2 = { class: "b-base-title h-mt-10" }
const _hoisted_3 = { class: "h-mt-15" }
const _hoisted_4 = { style: {"min-width":"120px","height":"60px"} }
const _hoisted_5 = { class: "b-location-input" }
const _hoisted_6 = {
  style: {"width":"100%"},
  class: "fw-select-base"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeaturesSaveButton = _resolveComponent("FeaturesSaveButton")!
  const _component_SelectAddress = _resolveComponent("SelectAddress")!
  const _component_FwFormInput = _resolveComponent("FwFormInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FeaturesSaveButton, {
      disabled: (![_ctx.LOCATION_VALUE] && !_ctx.address) || ([_ctx.LOCATION_VALUE] && _ctx.location === _ctx.address),
      onClick: _ctx.setLocationHandler
    }, null, 8, ["disabled", "onClick"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('EVENT.NAME.LOCATION')), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("form", _hoisted_3, [
        _createVNode(_component_FwFormInput, {
          class: "h-mb-25",
          fieldHasError: _ctx.fieldHasErrorByRule(_ctx.location_value || ``, _ctx.LOCATION_VALUE, _ctx.locationRules),
          labelType: "label-thin",
          title: _ctx.$t("EVENT.NAME.LOCATION")
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_SelectAddress, {
                    startAddress: _ctx.address,
                    placeholderText: "EVENT.NAME.LOCATION",
                    onChangePostCode: _cache[0] || (_cache[0] = value => _ctx.post_code = value),
                    onInput: _ctx.input
                  }, null, 8, ["startAddress", "onInput"])
                ])
              ]),
              (_ctx.location && !_ctx.isCleared)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "b-location-input__clean",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cleanAddress && _ctx.cleanAddress(...args)))
                  }, _toDisplayString(_ctx.$t('BUTTON.DELETE')), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["fieldHasError", "title"])
      ])
    ])
  ]))
}